<template>
  <div class="input-relative">
    <div class="form-select" :class="{ 'select-error': hasError }">
      <select
        :value="value"
        :name="name"
        :disabled="readonly"
        @change="handleChange"
        @click="preventChangeIfReadonly"
      >
        <option value="">
          -- {{ $t('register-page.step-two.choose', { split: '/' }) }} --
        </option>
        <slot name="options"></slot>
      </select>
    </div>
    <span v-if="showRequiredError" class="form-error-tip">
      {{ $t('validate.required', { split: '/' }) }}
    </span>
    <slot name="example"></slot>
  </div>
</template>

<script>
export default {
  name: 'SelectField',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    validationErrors: {
      type: Object,
      default: () => ({
        required: false
      })
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showRequiredError() {
      return this.validationErrors.required;
    }
  },
  methods: {
    handleChange(event) {
      this.$emit('input', event.target.value);
    },

    preventChangeIfReadonly(event) {
      if (this.readonly) {
        event.preventDefault();
      }
    }
  }
};
</script>
